import React from "react";
import VisibilitySensor from "react-visibility-sensor";

import {
  ActionType,
  SurfaceType,
  AnalyticsProperties,
} from "utils/analytics/analyticsConstants";
import { useAnalytics } from "utils/analytics/AnalyticsContext";

// treated as visible if the top 300px are visible;
const MINIMUM_VISIBLE_PIXEL_FROM_TOP = 300;

export interface VisibilityTrackerProps
  extends React.ComponentProps<typeof VisibilitySensor> {
  analyticsName: string;
  // TODO remove when we move to use AnalyticsProvider 100%
  analyticsSurface?: SurfaceType;
  analyticsProperties?: AnalyticsProperties;
  container?: React.ReactNode;
  children: React.ReactNode;
}

export default function VisibilityTracker(props: VisibilityTrackerProps) {
  const {
    analyticsName,
    analyticsSurface,
    analyticsProperties,
    container,
    children,
  } = props;

  const { trackEvent } = useAnalytics("VisibilityTracker" + analyticsName);

  return (
    <VisibilitySensor
      partialVisibility
      delayedCall
      minTopValue={MINIMUM_VISIBLE_PIXEL_FROM_TOP}
      containment={container}
      onChange={(isVisible: boolean) => {
        if (isVisible) {
          trackEvent({
            eventType: ActionType.VPV,
            eventName: analyticsName,
            analyticsSurface,
            extraProperties: analyticsProperties,
          });
        }
      }}
    >
      {children}
    </VisibilitySensor>
  );
}
